<template>
  <div role="main" class="main agenda">
    <div v-if="ready==false" class="loader">
      <div class="container">
        <div class="row">
          <div class="col-sm-1 mx-md-auto mt-2 text-center">
            <spring-spinner
                :animation-duration="5000"
                :size="60"
                color="#124191"
            />
          </div>
        </div>

      </div>
    </div>
    <div v-else>
      <div class="container">
        <div class="row mt-5 pb-3">
          <div class="col-md-12 mx-md-auto text-uppercase text-center">
            <h2 class="font-weight-normal text-9 mb-3">Agenda</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mx-md-auto text-center">
            <h3 class="font-weight-normal text-6 mb-3">
              <span>{{ date }}</span>
              <img :src="require('../assets/img/pin.png')" style="" alt="" />
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="row" v-for="(st, idx) in agenda">
              div
            </div>
<!--            <div class="table-agenda">-->
<!--              <div class="header">-->
<!--                <div class="th"><p>Stage <span>1</span></p></div>-->
<!--                <div class="th"><p>Stage <span>2</span></p></div>-->
<!--              </div>-->
<!--              <div class="session-row" v-for="(st, idx) in agenda" :key="idx">-->
<!--                <div class="session-column">-->
<!--                  <div class="session-content shr" v-if="st.type === 'shared'">-->
<!--                    <p>Shared {{ st.stage }}</p>-->
<!--                  </div>-->
<!--                  <div class="session-content" v-else-if="st.type === 'break'">-->
<!--                    <div class="break">-->
<!--                      <p>-->
<!--                        Coffee Break{{ st.stage }}-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="session-content s" v-else>-->
<!--                    <p>Session{{ st.stage }}</p>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import {SpringSpinner} from "epic-spinners";

export default {
  name: "AgendaExt",
  props: ["info"],
  components: {
    SpringSpinner
  },
  data() {
    return {
      agenda: [],
      date: '',
      ready: false,
      log: console.log
    }
  },
  methods: {
    getDate(){
      axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/agenda_settings')
          .then(response => {
            this.date = response.data.data[0].event_date;
          })
    },
    _fillData(st1, st2) {
      switch (st1.stage.id) {
        case 1:
          return {st1:st1, st2:st2}
        case 2:
          return {st1:st2, st2:st1}
      }

      return {st1:{}, st2:{}}
    },
    getAgenda() {
      axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/agenda_ext?fields=id,type,stage,name,time,lectures.lecture_title,lectures.slug,lectures.lectures_authors.authors_id.first_name,lectures.lectures_authors.authors_id.last_name,lectures.lectures_authors.authors_id.slug&sort=order')
        .then(response => {
          const agendaItems = response.data.data
          let agendaStageOne = []
          let agendaStageTwo = []
          agendaItems.forEach((item) => {
            const stage = item.stage
            switch (stage.id) {
              case 1:
                agendaStageOne.push(item)
                break
              case 2:
                agendaStageTwo.push(item)
                break
              default:
                console.log("unknown stage: " + stage.id)
            }
          })
          let stage1 = []
          let stage2 = []
          if (agendaStageOne.length < agendaStageTwo.length) {
            stage1 = agendaStageTwo
            stage2 = agendaStageOne
          } else {
            stage1 = agendaStageOne
            stage2 = agendaStageTwo
          }

          let agnItm = {st1:[], st2:[]}
          stage1.forEach((it, idx) => {
            let res = {st1:{}, st2: {}}
            switch (it.type) {
              case "shared":
                if (typeof stage2[idx] !== "undefined") {
                  if (stage2.type !== "shared") {
                    res = this._fillData(it, stage2[idx])
                  } else {
                    res = this._fillData(it, {})
                  }
                }
                break;
              default:
                if (typeof stage2[idx] !== "undefined") {

                } else {
                  res = this._fillData(it, {})
                }
                break
            }

            agnItm.st1.push(res.st1)
            agnItm.st2.push(res.st2)
          })

          console.log(this.agenda)
          this.ready = true
        })
    }
  },
  created() {
    this.getAgenda()
  }
}
</script>

<style lang="scss">
@import '@/assets/sass/variables.scss';
@import '@/assets/sass/agenda.scss';
</style>
